<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="poppins planned-content no-top-padding h-100">
        <div v-if="loaded" class="h-100 d-flex flex-column">
          <div class="d-flex justify-content-end">
            <span>
              <b-button variant="primary" size="lg" class="mr-3" v-b-modal.confirmationSetDefaultPlanValue>
                {{ 'Set default plan values' | i18n }}
              </b-button>
              <ConfirmationModal :setDefaultPlanValue="setDefaultPlanValue" />
            </span>
            <span v-if="isSaving">
              <b-button variant="primary" size="lg" disabled>
                <b-spinner small />
                {{ 'saving' | i18n }}
              </b-button>
            </span>
            <span v-else>
              <b-button variant="primary" size="lg" @click="create">
                {{ 'save' | i18n }}
              </b-button>
            </span>
          </div>
          <BlockHeader name="Details" class="mt-0" />
          <div class="row">
            <div class="col-lg-6 col-sm-6 col-xs-12">
              <Select v-model="selectedYear" :on-change="init" :options="yearOptions" form-group-id="Year" placeholder="year" />
            </div>
            <div class="col-lg-3 col-sm-4 col-xs-12">
              <Select v-model="selectedMonth" :options="monthOptions" form-group-id="month" placeholder="Month" />
            </div>
          </div>
          <Lines :set-backend-data="setBackendData" :backend-data="backendData[selectedMonth]" />
        </div>
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import Lines from './lines';

import moment from 'moment';
import api from '../../../api';
import Notification from '../../common/notification';

import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';
import ConfirmationModal from './confirmation-modal';

const currentYear = Number(moment().format('YYYY'));
const currentMonth = Number(moment().format('MM'));

export default {
  title: 'Planned Values',
  components: { Loader, BlockHeader, Select, Lines, ConfirmationModal },
  data() {
    return {
      loaded: false,
      isSaving: false,
      selectedYear: currentYear,
      selectedMonth: currentMonth,
      yearOptions: [],
      monthOptions: moment.months().map((monthName, i) => ({ value: i + 1, text: monthName })),
      names: {},
      yearData: {
        year: '',
        days: [],
      },
      backendData: {},
      allInfo: {},
    };
  },
  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.init();
  },
  methods: {
    setDefaultPlanValue() {
      this.yearData.days.forEach((day) => {
        this.backendData[Number(moment(day.date).format('MM'))][day.date]['BStdA1Plan'] = 24;
        this.backendData[Number(moment(day.date).format('MM'))][day.date]['BStdA2Plan'] = 24;
        this.backendData[Number(moment(day.date).format('MM'))][day.date]['BStdA3Plan'] = 24;
        this.backendData[Number(moment(day.date).format('MM'))][day.date]['BStdA4Plan'] = 24;
      });
    },
    setBackendData(v, name, date) {
      this.backendData[this.selectedMonth][date][name] = v;
    },
    async init() {
      localStorage.setItem('selectedYear', this.selectedYear);
      this.loaded = false;
      const response = await api.calendar.get({ year: this.selectedYear });

      this.backendData = {};
      this.yearData = {
        year: '',
        days: [],
      };

      const responseData = {};
      if (response && response.days && response.days.length) {
        response.days.forEach((d) => {
          responseData[d.date] = d;
        });
      }
      
      const startDate = moment(`${this.selectedYear}-01-01`);

      const a = moment([this.selectedYear, 11, 31]);
      const b = moment([this.selectedYear, 0, 1]);
      const currentAmountOfDays = a.diff(b, 'days');

      Array.from({ length: currentAmountOfDays + 1 }, (_, i) => {
        const day = i + 1;
        const week = startDate.isoWeek();
        this.yearData.year = this.selectedYear;

        const d = {
          date: startDate.format('YYYY-MM-DD'),
          type: '',
          hint: '',
          'Kalender-woche': day < 10 && week > 1 ? 0 : week,
          'Tag des Jahres': day,
          BStdA1Plan: '',
          BStdA2Plan: '',
          BStdA3Plan: '',
          BStdA4Plan: '',
          BStdA1Ist: '',
          BStdA2Ist: '',
          BStdA3Ist: '',
          BStdA4Ist: '',
        };

        const currentDay = responseData[d.date] || d;

        if (!this.backendData[Number(startDate.format('MM'))]) {
          this.backendData[Number(startDate.format('MM'))] = {};
        }
        this.backendData[Number(startDate.format('MM'))][startDate.format('YYYY-MM-DD')] = currentDay;

        this.yearData.days.push(currentDay);

        startDate.add(1, 'day');
      });

      this.loaded = true;
    },
    async create() {
      try {
        this.isSaving = true;
        await api.calendar.create({
          year: this.selectedYear,
          days: this.yearData.days.map((d) => this.backendData[Number(moment(d.date).format('MM'))][d.date]),
        });
        Notification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
        this.init();
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}

.no-top-padding {
  padding-top: 0;
}

.line-header-wrapper {
  display: flex;
  background: rgb(247, 247, 249);
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 30px;
  div {
    display: flex;
    align-items: center;
    background: #f7f7f9;
  }
}

.line-wrapper {
  display: flex;
}

.hour-input {
  min-width: 95px;
  flex: 1;
  padding: 0 5px;
}

.number-text {
  min-width: 100px;
  width: 100px;
  padding: 0 5px;
  text-align: center;
  justify-content: center;
}

.date-text {
  min-width: 110px;
  width: 110px;
  padding: 0 5px;
}

.type-input {
  min-width: 150px;
  width: 150px;
  padding: 0 5px;
}

.hint-input {
  min-width: 150px;
  width: 150px;
  padding: 0 5px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
